import { Outlet } from 'react-router-dom';
import { Grid } from '@mui/material';

export const PublicLayout = () => {
  return (
    <Grid container justifyContent="center" alignItems="center" height="100vh">
      <Outlet />
    </Grid>
  );
};
